import { formatFileSize } from "@/utils/formatFileSize";

import type { WorkspaceUsage } from "../sandbox/client/api";

/** From this share used, the composer warns that the workspace is nearly full. */
export const NEAR_FULL_SHARE = 0.9;

/** How much room the workspace has: plenty, nearly none (a warning), none (uploads are refused). */
export type WorkspaceRoom = "ok" | "near" | "full";

export function workspaceRoom(usage: WorkspaceUsage | null): WorkspaceRoom {
  if (!usage) return "ok";
  if (usage.free_bytes <= 0 || usage.used_share >= 1) return "full";
  return usage.used_share >= NEAR_FULL_SHARE ? "near" : "ok";
}

/** What the composer says about the room left, or null while there is plenty. */
export function roomMessage(usage: WorkspaceUsage | null): string | null {
  const room = workspaceRoom(usage);
  if (!usage || room === "ok") return null;
  const limit = formatFileSize(usage.max_bytes);
  if (room === "full") return `The workspace is full (${limit}).`;
  return `The workspace is ${Math.floor(usage.used_share * 100)}% full: ${formatFileSize(usage.free_bytes)} of ${limit} left.`;
}

/** Why `file` cannot be uploaded (no room for it), or null when it fits. */
export function uploadRefusal(
  file: { name: string; size: number },
  usage: WorkspaceUsage | null
): string | null {
  if (!usage || file.size <= usage.free_bytes) return null;
  if (workspaceRoom(usage) === "full") return roomMessage(usage);
  return `${file.name} is ${formatFileSize(file.size)}; the workspace has ${formatFileSize(usage.free_bytes)} left.`;
}
